import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export function QuestionnaireSkeleton () {
  return (
    <>
      {[0, 1, 2, 3, 4, 5].map((index) => (
        <Skeleton key={index} height={60} />
      ))}
    </>
  );
}
